(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 67154:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 64698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgCheckmark(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", { d: "M13.599 0L5.6 7.999 2.4 4.801 0 7.2l5.6 5.6L16 2.399 13.601 0z" }) })));


}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCheckmark);

/***/ }),

/***/ 1649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgShevronRightIcon(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ viewBox: "0 0 9 15" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1 13.107l6-6.04L1 1",
        strokeWidth: 2,
        stroke: "#EA6EA3",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round" }) })));



}

/* harmony default export */ __webpack_exports__["Z"] = (SvgShevronRightIcon);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 95044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85169);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var testimonials = [
{
  img:
  'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/839/c47/c9-/original/ann-sofie-42k.jpg',
  quote: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item1.quote" }),
  name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item1.name" }),
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item1.title" }) },

{
  img:
  'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/eb6/bda/dc-/original/lori-26k.jpg?1613380370',
  quote: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item2.quote" }),
  name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item2.name" }),
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item2.title" }) },

{
  img:
  'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/95b/917/98-/original/malinmagnusson-45k.jpg?1613380370',
  quote: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item3.quote" }),
  name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item3.name" }),
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item3.title" }) },

{
  img:
  'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/testimonials/images/82d/0a7/d4-/original/annaahlgren-41k.jpg?1613380371',
  quote: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item4.quote" }),
  name: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item4.name" }),
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.testimonials.item4.title" }) }];



var Title = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "TestimonialsSection__Title", componentId: "sc-u94rx0-0" })(["color:#3c3c3c;font-size:22px;text-align:center;"]);





var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "TestimonialsSection__Content", componentId: "sc-u94rx0-1" })(["display:grid;grid-template-columns:repeat(1,minmax(250px,1fr));row-gap:40px;margin:40px 0;@media (min-width:", "px){grid-template-columns:repeat(2,minmax(250px,1fr));}@media (min-width:", "px){grid-template-columns:repeat(auto-fill,minmax(250px,1fr));}"],





function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},



function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});




var Item = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({ displayName: "TestimonialsSection__Item", componentId: "sc-u94rx0-2" })(["flex:1;display:flex;flex-direction:column;align-items:center;text-align:center;@media (max-width:", "px){:nth-of-type(n + 3){display:none;}}"],






function (_ref3) {var theme = _ref3.theme;return theme.viewports.tablet;});






var Avatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])((next_image__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({ displayName: "TestimonialsSection__Avatar", componentId: "sc-u94rx0-3" })(["width:150px;border-radius:50%;margin-bottom:20px;overflow:hidden;"]);






var Quote = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "TestimonialsSection__Quote", componentId: "sc-u94rx0-4" })(["flex:1;color:#3c3c3c;font-size:16px;padding:0 14px;margin:10px 0 20px;"]);







var Name = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "TestimonialsSection__Name", componentId: "sc-u94rx0-5" })(["font-size:16px;margin:0;"]);




var PersonTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].p.withConfig({ displayName: "TestimonialsSection__PersonTitle", componentId: "sc-u94rx0-6" })(["margin:0;"]);



var TestimonialsSection = function TestimonialsSection(_ref4) {var _ref4$className = _ref4.className,className = _ref4$className === void 0 ? '' : _ref4$className;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
      className: className,
      flexDirection: "column",
      px: [25, 20, 20],
      py: 40, children: [/*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "landingpage.section7.title" }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Content, { children:
        testimonials.map(function (testimonial, i) {
          return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Item, { children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Avatar, { src: testimonial.img, alt: "", width: 150, height: 150 }), /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Quote, { children: testimonial.quote }), /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Name, { children: testimonial.name }), /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PersonTitle, { children: testimonial.title })] }, i));


        }) })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (TestimonialsSection);

/***/ }),

/***/ 73074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77495);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
var _excluded = ["open"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var useLoginModal = function useLoginModal()


{var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref$open = _ref.open,open = _ref$open === void 0 ? false : _ref$open,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(open),isOpen = _useState[0],setOpen = _useState[1];

  var content = /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, props), {}, { open: isOpen, onClose: function onClose() {return setOpen(false);} }));


  return [
  content,
  {
    isOpen: isOpen,
    openModal: function openModal() {return setOpen(true);},
    closeModal: function closeModal() {return setOpen(false);} }];


};

/* harmony default export */ __webpack_exports__["Z"] = (useLoginModal);

/***/ }),

/***/ 70021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97878);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var TrailerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Trailer__TrailerWrapper", componentId: "sc-191tqp1-0" })(["flex:1;position:relative;height:auto;padding-top:calc(", "%);@media (min-width:", "px){min-width:350px;}"],



function () {return (100 / 1.777).toFixed(2);},

function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;});




var TrailerVideo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_index__WEBPACK_IMPORTED_MODULE_2__["default"]).withConfig({ displayName: "Trailer__TrailerVideo", componentId: "sc-191tqp1-1" })(["position:absolute;top:0;left:0;width:100%;height:100%;"]);

















var Trailer = function Trailer(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerWrapper, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerVideo, _objectSpread({}, props)) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Trailer);

/***/ }),

/***/ 80753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _lang_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./ecosystems/landing_pages/hero/Hero.tsx
var Hero = __webpack_require__(83689);
// EXTERNAL MODULE: ./ecosystems/landing_pages/hero/components.ts
var components = __webpack_require__(23502);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./organisms/video-player/index.tsx + 11 modules
var video_player = __webpack_require__(97878);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var core_esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFuture/index.js
var isFuture = __webpack_require__(82644);
// EXTERNAL MODULE: ./lib/hooks/useFlags.tsx
var useFlags = __webpack_require__(55932);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/homepage/SquaresGrid.tsx










var Content = styled_components_browser_esm["default"].div.withConfig({ displayName: "SquaresGrid__Content", componentId: "sc-l7c05h-0" })(["display:flex;flex-direction:column;column-gap:15px;row-gap:15px;@media (min-width:", "px){flex-direction:row;}"],





function (_ref) {var theme = _ref.theme;return theme.viewports.laptop;});




var Items = styled_components_browser_esm["default"].div.withConfig({ displayName: "SquaresGrid__Items", componentId: "sc-l7c05h-1" })(["flex:1;display:grid;grid-gap:15px;@media (min-width:", "px){grid-template-columns:repeat(2,minmax(250px,50%));}"],




function (_ref2) {var theme = _ref2.theme;return theme.viewports.tablet;});




var Image = styled_components_browser_esm["default"].img.withConfig({ displayName: "SquaresGrid__Image", componentId: "sc-l7c05h-2" })(["max-width:100%;object-fit:cover;"]);




var GridElement = (0,styled_components_browser_esm["default"])((link_default())).withConfig({ displayName: "SquaresGrid__GridElement", componentId: "sc-l7c05h-3" })(["position:relative;width:100%;display:flex;flex-direction:column;text-decoration:none;background-color:", ";overflow:hidden;img{width:100%;height:100%;object-fit:cover;}@media (max-width:", "px){margin-bottom:15px;:nth-of-type(4){display:none;}}@media (min-width:", "px){flex-direction:row;}"],





function (_ref3) {var theme = _ref3.theme;return theme.colors.neutrals['light-gray'];},








function (_ref4) {var theme = _ref4.theme;return theme.viewports.mobile;},







function (_ref5) {var theme = _ref5.theme;return theme.viewports.mobile;});




// UTC time
var start_date = new Date(Date.UTC(2021, 10, 14, 23));
var end_date = new Date(Date.UTC(2021, 11, 9, 23));
var showCoursesSale = !(0,isFuture/* default */.Z)(start_date) && (0,isFuture/* default */.Z)(end_date);

var SquaresGrid_images = {
  program: {
    se: '/static/landing/65a4a761-b5c2-4e2c-bb60-61a71131e2c7.jpeg' },

  challenge: {
    se: '/static/landing/big_square_challenge_se.jpg',
    no: '/static/landing/big_square_challenge_no.jpg',
    en: '/static/landing/big_square_challenge_en.jpg',
    fi: '/static/landing/big_square_challenge_fi.jpg' },

  live: {
    se: '/static/landing/small_square_live_se.jpg',
    no: '/static/landing/small_square_live_no.jpg',
    en: '/static/landing/small_square_live_en.jpg',
    fi: '/static/landing/small_square_live_fi.jpg' },

  get_started: {
    se: '/static/landing/small_square_get_started_se.jpg',
    no: '/static/landing/small_square_get_started_no.jpg',
    en: '/static/landing/small_square_get_started_en.jpg',
    fi: '/static/landing/small_square_get_started_fi.jpg' },

  yogobe_team: {
    se: '/static/landing/small_square_team_se.jpg',
    no: '/static/landing/small_square_team_no.jpg',
    en: '/static/landing/small_square_team_en.jpg',
    fi: '/static/landing/small_square_team_fi.jpg' },

  courses: {
    se: showCoursesSale ?
    '/static/landing/courses_offer_se.jpeg' :
    '/static/landing/small_square_online_courses_se.jpg',
    no: '/static/landing/small_square_online_courses_no.jpg',
    en: '/static/landing/small_square_online_courses_en.jpg',
    fi: '/static/landing/small_square_online_courses_fi.jpg' } };



var SquaresGrid = function SquaresGrid() {var _currentUser$subscrip, _currentUser$subscrip2, _currentUser$subscrip3;
  var locale = (0,react.useContext)(languageContext/* default */.Z);
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 2),flags = _useFlags2[0],loading = _useFlags2[1].loading;
  var lang = ['en', 'fi'].includes(locale) ? 'en' : 'se';
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];

  var showYearlyCampaign = true;
  if (
  // user not loaded yet
  currentUser === undefined ||
  // user doesnt have trial premium
  (currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip = currentUser.subscription) === null || _currentUser$subscrip === void 0 ? void 0 : _currentUser$subscrip.status) === 'active' &&
  ['monthly', 'quarterly', 'yearly'].includes(
  currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$subscrip2 = currentUser.subscription) === null || _currentUser$subscrip2 === void 0 ? void 0 : (_currentUser$subscrip3 = _currentUser$subscrip2.currentSubscriptionPlan) === null || _currentUser$subscrip3 === void 0 ? void 0 : _currentUser$subscrip3.planType) ||

  // has wellness
  currentUser !== null && currentUser !== void 0 && currentUser.hasWellness)
  {
    showYearlyCampaign = false;
  }

  // default
  var banner = null;
  if (!loading) {
    if (flags.yearly_campaign_banners && showYearlyCampaign) {
      banner = /*#__PURE__*/
      (0,jsx_runtime.jsx)(GridElement, { href: "/se/yearly", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Image, {
          src:
          ['en', 'fi'].includes(lang) ?
          '/static/yearly/EN_Banner_Startpage_Square_b.jpg' :
          '/static/yearly/SE_Banner_Startpage_Square_b.jpg',

          loading: "lazy" }) });



    } else if (!flags.yearly_campaign_banners && flags !== null && flags !== void 0 && flags.yearly_campaign) {
      banner = /*#__PURE__*/
      (0,jsx_runtime.jsx)(GridElement, { href: "/".concat(lang, "/c/yogobe/b/spring-boost"), children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Image, {
          src:
          ['en', 'fi'].includes(lang) ?
          '/static/banner_springboost_en_startpage_square.jpg' :
          '/static/banner_springboost_startpage_square.jpg',

          loading: "lazy" }) });



    } else if (['se', 'no'].includes(locale)) {
      banner = /*#__PURE__*/
      (0,jsx_runtime.jsx)(GridElement, { href: "/".concat(locale, "/c/yogobe/b/spring-boost"), children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Image, {
          src: "/static/Campaign banner_Start page_1_1.jpg"
          // alt="Skapa nya, hållvara vanor i sommar – gå med i 16 Weeks of Well."
          , loading: "lazy" }) });



    }
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: "column", px: [25, 20, 20], py: 40, children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(Content, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { flex: 1, mb: [15, 15, 0], mr: [0, 0, 15], children:
          banner }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(Items, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(GridElement, {
            title: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.live"),
            href: "/".concat(lang, "/live"), children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Image, {
              src: SquaresGrid_images.live[lang],
              alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.live"),
              height: "480px",
              width: "480px" }) }), /*#__PURE__*/



          (0,jsx_runtime.jsx)(GridElement, {
            title: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.getstarted"),
            href: "/".concat(lang, "/traning-yoga-hemma"), children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Image, {
              src: SquaresGrid_images.get_started[lang],
              alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.getstarted"),
              height: "480px",
              width: "480px" }) }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(GridElement, {
            title: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.ybteam"),
            href: "/".concat(lang, "/team"), children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Image, {
              src: SquaresGrid_images.yogobe_team[lang],
              alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.ybteam"),
              height: "480px",
              width: "480px" }) }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(GridElement, {
            title: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.deepen_your_knowledge"),
            href: "/".concat(lang, "/marketplace/sales"), children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(Image, {
              src: SquaresGrid_images.courses[lang],
              alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.deepen_your_knowledge"),
              height: "480px",
              width: "480px" }) })] })] }) }));






};

/* harmony default export */ var homepage_SquaresGrid = (SquaresGrid);
// EXTERNAL MODULE: ./assets/ShevronRightIcon.js
var ShevronRightIcon = __webpack_require__(1649);
;// CONCATENATED MODULE: ./ecosystems/homepage/FouthSection.tsx







var FouthSection_Content = styled_components_browser_esm["default"].div.withConfig({ displayName: "FouthSection__Content", componentId: "sc-2t05le-0" })(["display:flex;flex-direction:column;flex-wrap:wrap;padding:20px;@media (min-width:", "px){flex-direction:row;}"],





function (_ref) {var theme = _ref.theme;return theme.viewports.laptop;});




var Item = styled_components_browser_esm["default"].div.withConfig({ displayName: "FouthSection__Item", componentId: "sc-2t05le-1" })(["flex:1;display:flex;flex-direction:column;:not(:last-of-type){margin-bottom:50px;}@media (min-width:", "px){:not(:last-of-type){margin-bottom:0;}:not(:last-of-type){border-right:1px solid lightgrey;padding-right:25px;margin-right:25px;}}"],








function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});












var Title = styled_components_browser_esm["default"].p.withConfig({ displayName: "FouthSection__Title", componentId: "sc-2t05le-2" })(["font-size:24px;margin:0 0 20px;"]);




var Desc = styled_components_browser_esm["default"].p.withConfig({ displayName: "FouthSection__Desc", componentId: "sc-2t05le-3" })(["flex:1;font-size:16px;margin:0 0 30px;"]);





var Link = styled_components_browser_esm["default"].a.withConfig({ displayName: "FouthSection__Link", componentId: "sc-2t05le-4" })(["display:flex;align-items:center;color:#ea6ea3;font-weight:500;text-transform:uppercase;text-decoration:none;svg{height:20px;margin-left:10px;}"]);













var FourthSection = function FourthSection() {
  var router = (0,next_router.useRouter)();
  var lang = router.query.lang;

  var items = [
  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item1.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item1.desc" }),
    link: "/".concat(lang, "/foretag/arbetsgivare") },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item2.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item2.desc" }),
    link: "/".concat(lang, "/blog/wellnet-actiway-benify-friskvardsbidrag") },


  {
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item3.title" }),
    desc: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.item3.desc" }),
    link: "/".concat(lang, "/non-profit") }];



  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: 'column', px: [25, 20, 20], py: 40, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(FouthSection_Content, { children:
        items.map(function (item, i) {
          return /*#__PURE__*/(
            (0,jsx_runtime.jsxs)(Item, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(Title, { children: item.title }), /*#__PURE__*/
              (0,jsx_runtime.jsx)(Desc, { children: item.desc }), /*#__PURE__*/
              (0,jsx_runtime.jsxs)(Link, { href: item.link, children: [/*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section4.readmore" }), /*#__PURE__*/
                (0,jsx_runtime.jsx)(ShevronRightIcon/* default */.Z, {})] })] }, i));



        }) }) }));



};

/* harmony default export */ var FouthSection = (FourthSection);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./ecosystems/homepage/FifthSection.tsx









var FifthSection_Title = styled_components_browser_esm["default"].h2.withConfig({ displayName: "FifthSection__Title", componentId: "sc-1k9cj4h-0" })(["color:#3c3c3c;font-size:24px;font-weight:400;text-align:center;"]);






var FifthSection_Content = styled_components_browser_esm["default"].div.withConfig({ displayName: "FifthSection__Content", componentId: "sc-1k9cj4h-1" })(["display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));grid-gap:20px;@media (min-width:", "px){grid-template-columns:repeat(2,minmax(250px,1fr));}@media (min-width:", "px){grid-template-columns:repeat(auto-fill,minmax(250px,1fr));}"],




function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},



function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});




var FifthSection_GridElement = (0,styled_components_browser_esm["default"])((link_default())).withConfig({ displayName: "FifthSection__GridElement", componentId: "sc-1k9cj4h-2" })(["display:flex;align-items:center;text-decoration:none;background-color:", ";overflow:hidden;img{height:100%;width:100%;}"],



function (_ref3) {var theme = _ref3.theme;return theme.colors.neutrals['light-gray'];});








var FifthSection = function FifthSection() {
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  var images = [
  {
    alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.news_yogobe"),
    se: {
      link: "/".concat(lang, "/videos/genres/all"),
      img: '/static/landing/small_square_news_yogobe_se.jpg' },

    no: {
      link: "/".concat(lang, "/videos/genres/all"),
      img: '/static/landing/small_square_news_yogobe_no.jpg' },

    en: {
      link: "/".concat(lang, "/videos/genres/all"),
      img: '/static/landing/small_square_news_yogobe_en.jpg' },

    fi: {
      link: "/".concat(lang, "/videos/genres/all"),
      img: '/static/landing/small_square_news_yogobe_fi.jpg' } },


  {
    alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.book_retreat"),
    se: {
      link: "/".concat(lang, "/marketplace"),
      img: '/static/landing/small_square_makretplace_se.jpg' },

    no: {
      link: "/".concat(lang, "/marketplace"),
      img: '/static/landing/small_square_makretplace_no.jpg' },

    en: {
      link: "/".concat(lang, "/marketplace"),
      img: '/static/landing/small_square_makretplace_en.jpg' },

    fi: {
      link: "/".concat(lang, "/marketplace"),
      img: '/static/landing/small_square_makretplace_fi.jpg' } },


  {
    alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.program_card"),
    se: {
      link: "/se/program/lopning-kom-igang",
      img: '/static/landing/small_square_program_se.jpg' },

    no: {
      link: "/no/program/yoga-for-lopere",
      img: '/static/landing/small_square_program_no.jpg' },

    en: {
      link: "/en/program/mindfulness-meditation",
      img: '/static/landing/small_square_program_en.jpg' },

    fi: {
      link: "/fi/ohjelmat/joogaa-aloittelijoille-viikko-1",
      img: '/static/landing/small_square_program_fi.jpg' } },


  {
    alt: /*i18n*/core_esm/* i18n._ */.ag._("landingpage.squareitems.alt_text.wellness_grant"),
    se: {
      link: "/".concat(lang, "/blog/wellnet-actiway-benify-friskvardsbidrag"),
      img: '/static/landing/small_square_wellness_grant_se.jpg' },

    no: {
      link: "/".concat(lang, "/blog/wellnet-actiway-benify-friskvardsbidrag"),
      img: '/static/landing/small_square_wellness_grant_no.jpg' },

    en: {
      link: "/".concat(lang, "/blog/wellnet-actiway-benify-friskvardsbidrag"),
      img: '/static/landing/small_square_wellness_grant_en.jpg' },

    fi: {
      link: "/".concat(lang, "/blog/wellnet-actiway-benify-friskvardsbidrag"),
      img: '/static/landing/small_square_wellness_grant_fi.jpg' } }];




  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", px: [25, 20, 20], py: 40, children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(FifthSection_Title, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section5.title" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(FifthSection_Content, { children:
        images.map(function (_item, i) {
          var item = _item[lang];
          return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(FifthSection_GridElement, { href: item.link, title: _item.alt, children: /*#__PURE__*/
              (0,jsx_runtime.jsx)((image_default()), { src: item.img, alt: _item.alt, height: 640, width: 640 }) }, i));


        }) })] }));



};

/* harmony default export */ var homepage_FifthSection = (FifthSection);
// EXTERNAL MODULE: ./ecosystems/homepage/TestimonialsSection.tsx
var TestimonialsSection = __webpack_require__(95044);
// EXTERNAL MODULE: ./components/MetaTags.tsx
var MetaTags = __webpack_require__(9128);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
;// CONCATENATED MODULE: ./ecosystems/homepage/MobileAppSection.tsx










var HeroSection = (0,styled_components_browser_esm["default"])(Hero/* default */.Z).withConfig({ displayName: "MobileAppSection__HeroSection", componentId: "sc-1lu5n8x-0" })(["position:relative;background-color:#dff4ff;", "{padding:40px 10px;margin:0 auto;", "{max-width:800px;color:#3c3c3c;justify-content:center;align-items:center;text-align:center;margin:0 auto;", "{font-size:24px;}", "{flex-wrap:wrap;justify-content:center;}}a{border:none;margin:0 10px;}a img{height:50px;}}@media (min-width:", "px){", "{width:80%;}", "{font-size:34px;}}"],



components/* TextWrapper */.OP,



components/* TextWrapperInner */.z5,







components/* SubTitle */.DK,



components/* ActionsWrapper */.T0,















function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},
components/* TextWrapper */.OP,



components/* SubTitle */.DK);





var MobileAppSection = function MobileAppSection() {
  var _useRouter =

  (0,next_router.useRouter)(),lang = _useRouter.query.lang;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(HeroSection, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.mobileapp_section.title" }),
      subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.mobileapp_section.desc" }),
      actions: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

        appearance: "link",
        href: constants/* IOS_APP_LINK */.G_,
        target: "_blank",
        rel: "noopener", children: /*#__PURE__*/

        (0,jsx_runtime.jsx)((image_default()), {
          alt: "",
          width: 150,
          height: 50,
          src:
          lang !== 'se' ?
          '/static/App_Store_Badge_en.svg' :
          '/static/App_Store_Badge_se.svg' }) }, "1"), /*#__PURE__*/



      (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

        appearance: "link",
        href: constants/* ANDROID_APP_LINK */.FG,
        target: "_blank",
        rel: "noopener", children: /*#__PURE__*/

        (0,jsx_runtime.jsx)((image_default()), {
          alt: "",
          width: 150,
          height: 50,
          src:
          lang !== 'se' ?
          '/static/google-play-badge-en.png' :
          '/static/google-play-badge-SE.png' }) }, "0")] }));






};

/* harmony default export */ var homepage_MobileAppSection = (MobileAppSection);
// EXTERNAL MODULE: ./assets/Checkmark.js
var Checkmark = __webpack_require__(64698);
// EXTERNAL MODULE: ./organisms/video-player/Trailer.tsx
var Trailer = __webpack_require__(70021);
// EXTERNAL MODULE: ./ecosystems/pricing/PricingSection.tsx + 2 modules
var PricingSection = __webpack_require__(27352);
;// CONCATENATED MODULE: ./pages/[lang]/index.tsx























var _lang_HeroSection = (0,styled_components_browser_esm["default"])(Hero/* default */.Z).withConfig({ displayName: "lang__HeroSection", componentId: "sc-757gnw-0" })(["position:relative;min-height:80vh;", "{width:100%;padding:0 20px;background-color:rgba(102,124,145,0.6);", "{align-items:center;font-size:12px;padding:10vh 0 0;margin:0 auto;}", "{color:white;font-size:1.6em;font-weight:400;line-height:1.3;text-align:center;}", "{color:white;font-size:3em;font-weight:500;line-height:1.2;text-align:center;}", " a{font-size:calc(1em + 2px);font-weight:500;padding:0.6em 1em;}", "{font-style:normal;margin-top:30px;ul{display:flex;flex-direction:column;align-items:center;list-style:none;color:white;font-size:16px;font-weight:600;padding-left:0;li{display:flex;align-items:center;margin-top:10px;svg{fill:white;height:14px;margin-right:10px;margin-top:4px;}}}}}", "{position:absolute;top:0;width:100%;height:100%;min-height:100%;img{object-fit:cover;object-position:center;}}@media (min-width:", "px){height:70vh;", "{position:absolute;top:0;width:100%;height:100%;padding:0 40px;", "{max-width:70%;font-size:2vw;padding-top:0;", "{font-size:1.4em;}", " a{font-size:0.9em;}", "{position:absolute;bottom:0;left:0;width:100%;font-style:normal;margin-bottom:0;padding:14px 20px;background-color:rgba(17,158,221,0.2);ul{max-width:860px;flex-direction:row;align-items:center;justify-content:center;margin:0 auto;li{margin-top:0;margin-right:50px;}}}}}", "{position:static;}}@media (min-width:", "px){", "{", "{font-size:1.4vw;", " a{font-size:0.8em;}}}}"],



components/* TextWrapper */.OP,




components/* TextWrapperInner */.z5,






components/* Title */.Dx,







components/* SubTitle */.DK,







components/* ActionsWrapper */.T0,





components/* Disclaimer */.em,





























components/* VideoWrapper */.U1,












function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},


components/* TextWrapper */.OP,






components/* TextWrapperInner */.z5,




components/* Title */.Dx,



components/* ActionsWrapper */.T0,



components/* Disclaimer */.em,

























components/* VideoWrapper */.U1,




function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;},
components/* TextWrapper */.OP,
components/* TextWrapperInner */.z5,


components/* ActionsWrapper */.T0);







var Description = styled_components_browser_esm["default"].div.withConfig({ displayName: "lang__Description", componentId: "sc-757gnw-1" })([""]);

var SecondSectionHero = (0,styled_components_browser_esm["default"])(Hero/* default */.Z).withConfig({ displayName: "lang__SecondSectionHero", componentId: "sc-757gnw-2" })(["", "{padding-bottom:20px;}", "{font-size:26px;font-weight:500;margin-bottom:10px;}", "{flex:1;display:flex;flex-direction:column;p{flex:1;font-size:18px;line-height:1.4;}}", "{top:8px;left:0;", "{text-transform:uppercase;border-radius:0;padding:8px;background-color:#56b9e5;}}", "{position:relative;display:flex;align-items:center;}"],
components/* TextWrapper */.OP,



components/* Title */.Dx,





Description,











video_player.Tags,



video_player.Tag,







components/* VideoWrapper */.U1);






var SixthSection = (0,styled_components_browser_esm["default"])(Hero/* default */.Z).withConfig({ displayName: "lang__SixthSection", componentId: "sc-757gnw-3" })(["p,h1,h3,span{color:white;}padding:0 20px;background-color:#5b96b7;", "{padding-bottom:10px;margin:0 auto;}", "{align-items:center;text-align:center;", "{font-size:20px;font-weight:400;margin-bottom:20px;}", "{font-size:24px;line-height:1.4;}button{color:#5b96b7;border-radius:50px;margin-bottom:20px;}", "{font-size:16px;margin-top:20px;}}@media (min-width:", "px){", "{", "{font-size:34px;}}}"],










components/* TextWrapper */.OP,




components/* TextWrapperInner */.z5,



components/* Title */.Dx,





components/* SubTitle */.DK,










components/* Disclaimer */.em,





function (_ref3) {var theme = _ref3.theme;return theme.viewports.tablet;},
components/* TextWrapperInner */.z5,
components/* SubTitle */.DK);






var Anchor = styled_components_browser_esm["default"].a.withConfig({ displayName: "lang__Anchor", componentId: "sc-757gnw-4" })(["&&{color:inherit;text-decoration:none;}"]);






var trailer = {
  id: '1e73f7ef-06b3-4235-a580-7215f88a38f8',
  content: { title: 'Home video trailer' },
  identifier: '2z3h',
  thumbnailUrl:
  'https://yogobe.23video.com/64968568/65791722/be188418308c9c0b595a975ee9d28e26/large/embed/thumbnail.jpg',
  hls:
  'https://yogobe.23video.com/64968568/65791722/664f16a0fa65c1f764aa85f78a076e9f/video_hls/playlist.m3u8',
  player: {
    hasAccess: true,
    assets: [
    {
      src:
      'https://yogobe.23video.com/64968568/65791722/664f16a0fa65c1f764aa85f78a076e9f/video_mobile_high/yogobestartpagetrailers1920x1080ons-video.mp4',
      resolution: 180,
      size: 2043187 },

    {
      src:
      'https://yogobe.23video.com/64968568/65791722/664f16a0fa65c1f764aa85f78a076e9f/video_medium/yogobestartpagetrailers1920x1080ons-video.mp4',
      resolution: 360,
      size: 4189153 },

    {
      src:
      'https://yogobe.23video.com/64968568/65791722/664f16a0fa65c1f764aa85f78a076e9f/video_hd/yogobestartpagetrailers1920x1080ons-video.mp4',
      resolution: 720,
      size: 6327752 },

    {
      src:
      'https://yogobe.23video.com/64968568/65791722/664f16a0fa65c1f764aa85f78a076e9f/video_1080p/yogobestartpagetrailers1920x1080ons-video.mp4',
      resolution: 1080,
      size: 12754101 }] } };





var Homepage = function Homepage(_ref4) {var _trailer$player;var _currentUser = _ref4.currentUser;
  var router = (0,next_router.useRouter)();
  var lang = router.query.lang;
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];

  var user = currentUser !== null && currentUser !== void 0 ? currentUser : _currentUser;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE",
        description: "Yoga & tr\xE4na online med n\xE5gra av Nordens fr\xE4msta instrukt\xF6rer. Digital yoga, tr\xE4ning, stresshantering och mer - var du vill, n\xE4r du vill." }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(_lang_HeroSection, {
        image: "/static/landing-hero-2.jpeg",
        title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.title" }),
        subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.subtitle" }),
        actions:
        !(user !== null && user !== void 0 && user.id) ?
        [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

          appearance: "default-blue",
          href: "/".concat(lang, "/register/account"), children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.cta" }) }, "0")] :


        null,

        disclaimer: /*#__PURE__*/
        (0,jsx_runtime.jsxs)("ul", { children: [/*#__PURE__*/
          (0,jsx_runtime.jsxs)("li", { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.bullet1" })] }), /*#__PURE__*/

          (0,jsx_runtime.jsxs)("li", { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {}), /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.bullet2" })] }), /*#__PURE__*/

          (0,jsx_runtime.jsxs)("li", { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {}), /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.hero.bullet3" })] })] }) }), /*#__PURE__*/




      (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexDirection: 'column', px: [25, 20, 20], py: 40, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(SecondSectionHero, {
          title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section2.title" }),
          description: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(Description, { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)("p", { children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section2.desc" }) }), /*#__PURE__*/
            (0,jsx_runtime.jsx)((link_default()), { href: "/".concat(lang, "/videos/genres/all"), legacyBehavior: true, children: /*#__PURE__*/
              (0,jsx_runtime.jsxs)(buttons/* default */.ZP, { appearance: "link", href: "/".concat(lang, "/videos/genres/all"), children: [/*#__PURE__*/
                (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section2.link" }), " >"] }) })] }),




          video: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Trailer/* default */.Z, {

            video: trailer,
            thumbnailImage: trailer === null || trailer === void 0 ? void 0 : trailer.thumbnailUrl,
            isLimited: false,
            autoPlay: false,
            videoSources: trailer === null || trailer === void 0 ? void 0 : (_trailer$player = trailer.player) === null || _trailer$player === void 0 ? void 0 : _trailer$player.assets,
            elementID: 'video1',
            tags: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section2.trailer_tag" }, "0")] }),



          reverseColumns: true }) }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(homepage_SquaresGrid, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(FouthSection, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(homepage_FifthSection, {}),
      !(user !== null && user !== void 0 && user.id) ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(SixthSection, {
        title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section6.title" }),
        subtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section6.subtitle" }),
        actions: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

          appearance: "default-white",
          href: "/".concat(lang, "/register/account"), children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section6.cta" }) }, "0")],


        disclaimer: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "landingpage.section6.disclaimer" }) }) :

      null, /*#__PURE__*/
      (0,jsx_runtime.jsx)(TestimonialsSection/* default */.Z, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(PricingSection/* default */.ZP, {}), /*#__PURE__*/
      (0,jsx_runtime.jsx)(homepage_MobileAppSection, {})] }));


};var __N_SSP = true;









/* harmony default export */ var _lang_ = (Homepage);

/***/ }),

/***/ 32707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]",
      function () {
        return __webpack_require__(80753);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,3088,6394,5675,8397,4746,2661,8618,9774,2888,179], function() { return __webpack_exec__(32707); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);